<script>
import { toDate } from "@/lib/date-utils"

export default {
  functional: true,

  props: {
    date: { type: String, required: true },
    noBorder: { type: Boolean, default: false }
  },

  render(h, { props }) {
    const classes = [
      "event-occurrence-date d-flex flex-column justify-content-end h-100 text-center font-weight-bold m-0"
    ]

    if (props.noBorder) classes.push("--no-border")

    return (
      <div class={classes}>
        <div class="event-occurrence-date__date-month">
          {toDate(props.date, "MMM")}
        </div>
        <div class="event-occurrence-date__date-day">
          {toDate(props.date, "DD")}
        </div>
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.event-occurrence-date {
  border-left: $size--2 solid var(--brand-color-hex);
  color: $color-ui--grey-90;
  padding: $size--4 $size--1 $size--4 $size--3;
  color: var(--brand-color-hex);

  &.--no-border {
    border-left: none;
  }
}

.event-occurrence-date__date-month {
  text-transform: uppercase;
}

.event-occurrence-date__date-day {
  font-size: $font-size--h1;
  line-height: 0.9;
}
</style>
